
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FlowPage } from '../flow-director';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { YshFlowContentComponent } from "../../components/ysh-flow-content/ysh-flow-content.component";
import { YshFlowNavBarComponent } from "../../components/ysh-flow-nav-bar/ysh-flow-nav-bar.component";
import { YshButtonControlComponent } from "../../components/ysh-button-control/ysh-button-control.component";
import { GroupItem, YshSelectList } from "../../components/ysh-select-list/ysh-select-list.component";
import { Role, ROLE_ACCESS_LABELS } from '../../models/affiliation';
import { titleCase } from '../../shared/string';

@Component({
    selector: 'ysh-select-role',
    templateUrl: './select-role.page.html',
    styleUrl: './select-role.page.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        YshFlowContentComponent,
        YshFlowNavBarComponent,
        YshButtonControlComponent,
        YshSelectList,
    ]
})
export class SelectRolePage implements OnInit, FlowPage {
  @Input() onComplete: (values: string[]) => void;
  @Input() onDismiss?: () => void;
  @Input() initialSelection: string[] = [];
  @Input() assignableRoles: Role[] = [];

  constructor(
    private analytics: AnalyticsService,
  ) {}

  roleSelection: string[] = [];

  roleItems: GroupItem[] = [];

  ngOnInit(): void {
    this.analytics.trackView('SelectRolePage');
    this.roleItems = [
      {
        title: null,
        items: this.assignableRoles
          .filter(role => ROLE_ACCESS_LABELS[role])
          .map(role => ({ value: titleCase(role), label: ROLE_ACCESS_LABELS[role] })),
      },
    ];
    this.roleSelection = [...this.initialSelection];
  }

  // Actions

  handleSelectionChange(values: string[]) {
    this.roleSelection = values;
    this.onComplete?.(values);
  }

  handleDismiss() {
    this.onDismiss?.();
  }  
}
